import type { Plugin } from "../types";
import limit from "../../__utils__/limit";
import subscribeFocus from "../../__utils__/subscribeFocus";
import { onUnmounted } from "vue";

const useRefreshOnWindowFocusPlugin: Plugin<any, any[]> = (
  fetchInstance,
  { refreshOnWindowFocus, focusTimespan = 5000 }
) => {
  let unsubscribe: () => void = () => {};

  const stopSubscribe = () => {
    unsubscribe?.();
  };

  if (refreshOnWindowFocus) {
    const limitRefresh = limit(fetchInstance.refresh.bind(fetchInstance), focusTimespan);
    unsubscribe = subscribeFocus(() => {
      limitRefresh();
    });
  }

  onUnmounted(() => {
    stopSubscribe();
  });

  return {};
};

export default useRefreshOnWindowFocusPlugin;
